import type { FaireProductEntity } from "../../entity_types/product";

export const p_xyzhx6ty4s: FaireProductEntity = {
  token: "p_xyzhx6ty4s",
  type: "product",
  name: "Paleo Vegan Banana Bread - 350 grams",
  brandToken: "b_7qrub4tp9v",
  brandName: "Konscious Kitchen Inc",
  imageUrl: "https://cdn.faire.com/fastly/1b3a7f94d3a75d460785408c854f9f32a184e3a6eae60ca87d41c9cfc8df1dd6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/81b0a55c9a2f6e78cb6da2a1ea5b93ce05886ac8629017d54c4dbc43ff68c928.jpeg",
    "https://cdn.faire.com/fastly/82b3c51556531aecb401181f6908e4d06ad2f36903de10a9da9301b0540211f7.png",
    "https://cdn.faire.com/fastly/4fe2e6fe3d22aafe75c7a92813b2982e9611a1f7d6b273332c8150271ed48a1f.png"
  ],
  priceDollars: 9.99,
  description: "Indulge in our rich, moist Paleo Vegan Chocolate Banana Bread, crafted with wholesome, gluten-free ingredients and naturally sweetened with bananas and a tinge of maple syrup. Perfect for those embracing clean, plant-based living without compromising on flavor!\n\nKey Features:\nGluten Free\nPaleo\nGrain Free\nVegan\n49 grams protein per Banana Bread\n\nIngredients:\nAlmond Flour, Organic Coconut Flour, Organic Psyllium Husk, Almond Butter, Organic Coconut Milk, Organic Maple Syrup, Himalayan Sea Salt, Baking Soda, Cream of Tartar, Organic Coconut Oil, Bananas, Semi Sweet Chocolate Chips (Cocoa Mass, Cocoa Butter, Brown Sugar)\n\nShelf Life:\nRefrigerated – 3 weeks\nFrozen - 6 months\n\n",
  tags: [],
  msrpDollars: 19.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:53.033Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
